var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsteroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 462.625 462.625",
    height: 512,
    viewBox: "0 0 462.625 462.625",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20d6de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e309d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 244.662,
    y2: 244.662
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 163.727,
    y2: 163.727
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 159.907,
    y2: 159.907
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 209.973,
    y2: 209.973
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 125.977,
    y2: 125.977
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 159.876,
    y2: 159.876
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 175.296,
    y2: 175.296
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 314.228,
    y2: 314.228
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 274.751,
    y2: 274.751
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 383.457,
    y2: 383.457
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 296.785,
    y2: 296.785
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 406.586,
    y2: 406.586
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 395.018,
    y2: 395.018
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 437.427,
    y2: 437.427
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.101,
    x2: 470.558,
    xlinkHref: "#lg1",
    y1: 213.844,
    y2: 213.844
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 190.715,
    y2: 190.715
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 275.522,
    y2: 275.522
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 460.554,
    y2: 460.554
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 452.844,
    y2: 452.844
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 0 0 -1 0 475.975)",
    gradientUnits: "userSpaceOnUse",
    x1: -23.108,
    x2: 470.55,
    xlinkHref: "#lg1",
    y1: 445.135,
    y2: 445.135
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Gradient_outline_2_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.216 267.127c-5.394 18.412-8.153 37.496-8.195 56.682 0 79.117 62.973 138.774 146.484 138.774 69.73 1.681 130.963-46.067 146.33-114.103.655-3.277 1.264-6.453 1.85-9.537 6.168-32.581 10.285-54.099 57.26-94.058 104.335-88.685 102.315-123.14 99.979-163.03-2.698-24.224.781-48.737 10.115-71.253 1.598-3.947-.307-8.442-4.254-10.039-1.406-.569-2.949-.711-4.435-.407-.771.162-82.293 17.362-98.53 98.53-10.601 53.004-44.069 66.38-60.428 69.765 7.072-36.156 20.352-70.814 39.25-102.438 2.287-3.592 1.229-8.357-2.363-10.644-2.343-1.492-5.307-1.608-7.76-.304-8.556 3.986-17.646 6.71-26.984 8.087-19.066 3.809-40.653 8.134-62.788 31.417-22.865 19.647-49.683 34.154-78.639 42.542-8.689 2.922-17.671 5.952-27.046 9.969-62.509 26.813-98.328 62.702-119.846 120.047zm125.907-105.847c8.812-3.77 17.108-6.569 25.889-9.521 30.906-9.062 59.526-24.608 83.951-45.603.231-.208.455-.416.671-.64 18.858-20.045 37.191-23.669 54.916-27.215 3.577-.717 7.201-1.442 10.794-2.313-16.439 31.2-27.481 64.956-32.658 99.84-4.288 21.46-14.196 41.398-28.711 57.776l10.917 10.886c15.432-17.018 26.323-37.653 31.664-59.997 17.216-2.452 64.9-15.296 78.377-82.717 7.948-38.348 35.564-69.643 72.625-82.301-6.156 20.491-8.189 41.999-5.983 63.281 2.174 37.245 3.901 66.673-94.567 150.339-51.131 43.459-55.872 68.393-62.448 102.901-.571 3.038-1.164 6.168-1.773 9.182-13.886 60.922-68.816 103.594-131.28 101.984-74.714 0-131.065-53.035-131.065-123.355.042-17.335 2.473-34.582 7.224-51.254 20.144-53.743 52.432-85.977 111.457-111.273z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.268 370.598c8.465.033 16.665 2.96 23.237 8.296 1.991 1.628 3.198 4.023 3.323 6.592.003 3.317 2.126 6.261 5.273 7.309l22.474 7.494c3.705 2.412 6.858 5.581 9.252 9.298 5.063 8.871 14.465 14.375 24.679 14.448 59.585-.064 107.872-48.351 107.935-107.935.046-22.602-7.083-44.636-20.361-62.926-.367-7.772-1.328-15.504-2.876-23.129-.321-1.962-1.387-3.724-2.976-4.919l-30.839-23.129c-1.689-1.253-3.814-1.77-5.89-1.434l-46.258 7.71c-3.682.637-6.389 3.804-6.445 7.54-.432 10.107-6.688 19.046-16.036 22.913l-36.39-7.278c-2.241-.454-4.569.111-6.353 1.542-41.128 31.359-53.387 87.947-28.927 133.516 1.374 2.661 4.187 4.265 7.178 4.092zm28.657-123.355 18.033 3.608-17.046 12.821 9.252 12.335 24.316-18.233 10.901 16.345 12.829-8.558-10.516-15.766c9.774-6.093 16.583-15.967 18.804-27.269l37.276-6.168 25.712 19.274c1.087 6.939 2.058 14.402 2.136 17.231-.772 2.408-.314 5.041 1.226 7.047 12.454 16.08 19.2 35.849 19.174 56.188 0 1.449-.154 2.868-.216 4.302l-8.481-8.481-7.139-21.402-14.648 4.873 5.59 16.784-9.437 4.718 6.892 13.8 10.454-5.227 13.877 13.877c-10.597 40.727-47.327 69.184-89.409 69.271-5.852 0-7.887-2.405-12.335-8.319-3.821-5.711-8.911-10.461-14.872-13.877-.376-.198-.768-.363-1.172-.493l-18.65-6.253c-1.286-4.587-3.828-8.723-7.34-11.942-8.259-7.108-18.542-11.442-29.397-12.389-17.819-37.286-7.832-81.922 24.178-108.059z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.671 346.69 30.839 7.71 3.731-14.957-14.88-3.716c7.085-12.149 7.085-27.17 0-39.319l14.88-3.716-3.731-14.957-30.839 7.71c-12.012 1.311-21.263 14.217-21.263 30.654 0 16.436 9.252 29.342 21.263 30.591zm1.866-46.011c3.146 0 7.71 6.006 7.71 15.419s-4.564 15.419-7.71 15.419-7.71-6.006-7.71-15.419 4.565-15.419 7.71-15.419z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.485 295.66c4.947.222 9.774-1.56 13.392-4.942 9.745-9.737 3.963-30.068-7.71-41.74s-31.987-17.462-41.74-7.71c-9.753 9.753-3.963 30.068 7.71 41.74 7.543 7.603 17.653 12.115 28.348 12.652zm-25.164-43.482c.696-.414 1.507-.595 2.313-.517 6.671.559 12.926 3.472 17.647 8.219 5.646 5.003 8.519 12.43 7.71 19.93-14.575.706-26.962-10.537-27.668-25.112-.041-.84-.041-1.681-.002-2.52z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.156 388.169c10.697-.535 20.807-5.047 28.348-12.652 11.233-11.233 16.861-30.407 8.589-40.514l.085-.054-15.419-23.129-12.829 8.558 6.314 9.467c-7.837 1.961-15.007 5.98-20.77 11.642-6.671 6.733-10.996 15.435-12.335 24.817l-10.647-3.546-4.873 14.648 21.988 7.332c3.384 2.348 7.431 3.55 11.549 3.431zm5.219-35.781c4.73-4.753 10.996-7.669 17.678-8.226.806-.082 1.616.097 2.313.509.826 7.506-2.05 14.946-7.71 19.945-5.003 5.646-12.43 8.519-19.93 7.71-.838-7.494 2.014-14.928 7.649-19.938z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.086 308.389h15.419v15.419h-15.419z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.505 292.969h15.419v15.419h-15.419z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.456 177.031c55.618-15.897 94.69-62.155 96.332-64.152l-11.85-9.884c-.37.447-37.777 44.647-89.008 59.295-78.084 25.704-94.76 46.805-96.371 49.126l12.436 9.082c.17-.223 15.828-19.559 88.461-43.467z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359.292 198.911c32.134-24.093 57.052-64.545 57.052-83.265h-15.419c0 11.248-19.814 47.63-50.676 70.783-78.724 55.101-87.613 95.623-87.944 97.288l15.103 3.084c.077-.308 8.958-36.836 81.884-87.89z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.505 84.808h15.419v15.419h-15.419z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.976 194.286 9.252 12.335c1.334-1.002 32.859-24.864 41.231-49.99l-14.648-4.873c-6.824 20.54-35.55 42.312-35.835 42.528z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.634 61.679h15.419v15.419h-15.419z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.918 49.344-23.129 30.839c-2.555 3.406-1.864 8.239 1.542 10.794l30.839 23.129c1.335 1.001 2.958 1.542 4.626 1.542 1.196-.001 2.375-.278 3.446-.81l30.839-15.419c2.015-1.008 3.488-2.848 4.032-5.034l7.71-30.839c1.029-4.132-1.487-8.315-5.619-9.344-.197-.049-.395-.09-.595-.124l-46.258-7.71c-2.838-.461-5.698.684-7.433 2.976zm42.927 18.572-3.354 13.407-22.25-11.125-6.892 13.8 17.046 8.519-12.79 6.391-20.855-15.642 15.697-20.924z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.456 53.569 23.129 7.71c.785.266 1.608.401 2.436.401 1.523 0 3.012-.45 4.279-1.295l23.129-15.419c3.543-2.361 4.502-7.147 2.141-10.691-.746-1.119-1.771-2.023-2.974-2.624l-30.839-15.419c-3.478-1.737-7.705-.614-9.861 2.621l-15.419 23.129c-2.35 3.551-1.376 8.334 2.174 10.684.56.371 1.167.667 1.804.88v.023zm20.5-20.501 12.867 6.438-8.935 5.983-9.976-3.315z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.053 231.292h-30.839c-2.045 0-4.005.813-5.451 2.259l-23.129 23.129c-3.011 3.011-3.011 7.892 0 10.903.258.258.533.497.825.715l30.839 23.129c1.335 1.001 2.958 1.542 4.626 1.542 1.193.011 2.372-.253 3.446-.771l30.839-15.419c3.232-1.616 4.909-5.26 4.032-8.766l-7.71-30.839c-.841-3.448-3.928-5.877-7.478-5.882zm-22.358 44.94-19.914-14.934 10.2-10.192 10.2 15.304 12.829-8.558-7.394-11.14h10.416l4.749 18.997z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.247 277.55h15.419v15.419h-15.419z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.053 192.744h15.419v15.419h-15.419z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.279 7.711h15.419v15.419h-15.419z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.924 15.421h15.419v15.419h-15.419z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.957 23.131h15.419v15.419h-15.419z",
    fill: "url(#SVGID_20_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsteroid);
export default __webpack_public_path__ + "static/media/asteroid.7252a113fd466b9fea85dc50063bd79f.svg";
export { ForwardRef as ReactComponent };